import { render, staticRenderFns } from "./medicineMessageEdit.vue?vue&type=template&id=2d30198e&"
import script from "./medicineMessageEdit.vue?vue&type=script&lang=js&"
export * from "./medicineMessageEdit.vue?vue&type=script&lang=js&"
import style0 from "./medicineMessageEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports